module.exports = __webpack_public_path__ + "media/newstyle/images/icon_linkedin-cbf96822cea6df9977ad75aabd814681.svg";